export const apiUrl = process.env.REACT_APP_API_GATEWAY_SEGMENTER;

// This need to be pointed to staging aggregator API once it is available
export const aggregatorApiUrl = process.env.REACT_APP_API_GATEWAY_AGGREGATOR;

export const campaignBriefApiUrl = process.env.REACT_APP_API_GATEWAY_SEGMENTER;

export const logoutApiUrl = process.env.REACT_APP_API_GATEWAY_LOGOUT;

export const campaignNavigatorUrl = process.env.REACT_APP_API_CAMPAIGN_NAVIGATOR_API;
